import { render, staticRenderFns } from "./CertificatType.vue?vue&type=template&id=7aebee43&scoped=true&"
import script from "./CertificatType.vue?vue&type=script&lang=js&"
export * from "./CertificatType.vue?vue&type=script&lang=js&"
import style0 from "./CertificatType.vue?vue&type=style&index=0&id=7aebee43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aebee43",
  null
  
)

export default component.exports